import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Stack component for consistent spacing and alignment
 * @param children - Stack items
 * @param className - Additional CSS classes
 * @param direction - Stack direction (vertical or horizontal)
 * @param gap - Gap size between items
 * @param align - Cross-axis alignment
 * @param justify - Main-axis alignment
 * @returns JSX element with flex layout
 */
const Stack = ({ children, className, direction = 'vertical', gap = 'md', align, justify, }) => {
    const directionClasses = {
        horizontal: 'flex-row',
        vertical: 'flex-col',
    };
    const gapClasses = {
        none: 'gap-0',
        xs: 'gap-1',
        sm: 'gap-2',
        md: 'gap-4',
        lg: 'gap-6',
        xl: 'gap-8',
        '2xl': 'gap-12',
    };
    const alignClasses = {
        start: 'items-start',
        center: 'items-center',
        end: 'items-end',
        stretch: 'items-stretch',
    };
    const justifyClasses = {
        start: 'justify-start',
        center: 'justify-center',
        end: 'justify-end',
        between: 'justify-between',
        around: 'justify-around',
        evenly: 'justify-evenly',
    };
    return (jsx("div", { className: cn('flex', directionClasses[direction], gapClasses[gap], align && alignClasses[align], justify && justifyClasses[justify], className), children: children }));
};

export { Stack };
//# sourceMappingURL=Stack.js.map
